import {createUseQuery, createUseMutation} from "@irati/utils/services/apollo"
import getNotificationCountQuery from "../apollo/queries/count"
import clearNotificationCountMutation from "../apollo/mutations/clear"
import {MutationClearNotificationCountArgs, NotificationChannel, NotificationKind, QueryNotificationCountArgs} from "@irati/types"

export const recognitionNotificationsCountVariables = {
  kind: NotificationKind.Badge,
  channel: NotificationChannel.CelebrationFeed
}
export const useNotificationCountQuery = createUseQuery<number, QueryNotificationCountArgs>(getNotificationCountQuery, {
  key: "notificationCount"
})
export const useClearNotificationCountMutation = createUseMutation<boolean, MutationClearNotificationCountArgs>(
  clearNotificationCountMutation,
  {
    key: "clearNotificationCount"
  }
)
